namespace TabAurous.OMS {
    export interface DenominationForm {
        Code: Serenity.DecimalEditor;
        Name: Serenity.StringEditor;
    }

    export class DenominationForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.Denomination';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DenominationForm.init)  {
                DenominationForm.init = true;

                var s = Serenity;
                var w0 = s.DecimalEditor;
                var w1 = s.StringEditor;

                Q.initFormType(DenominationForm, [
                    'Code', w0,
                    'Name', w1
                ]);
            }
        }
    }
}
